import { IconButton, type IconButtonProps } from "./ui/IconButton"
import { Tooltip, type TooltipProps } from "./ui/Tooltip"

interface Props extends IconButtonProps {
  tooltipProps: Omit<TooltipProps, "children">
}

export const TooltipIconButton = ({ tooltipProps, ref, ...iconButtonProps }: Props) => (
  <Tooltip {...tooltipProps}>
    <IconButton {...iconButtonProps} ref={ref} />
  </Tooltip>
)
